"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCard = void 0;
const react_1 = __importDefault(require("react"));
const Checkbox_1 = require("./Checkbox");
const Card_1 = require("./Card");
const Detail_1 = require("./Detail");
const SelectCard = ({ title, description, checkbox, checkboxId, checkboxIsToggle, form, bgSecondary, }) => {
    const emulateCheckboxClick = () => {
        if (checkbox && checkboxId) {
            form === null || form === void 0 ? void 0 : form.setFieldValue(checkboxId, !form.values[checkboxId]);
        }
    };
    return (react_1.default.createElement(Card_1.Card, { onClick: emulateCheckboxClick, interactive: true, spaced: true, bgSecondary: bgSecondary, withAction: true, reverse: checkboxIsToggle },
        checkboxId && (react_1.default.createElement(Checkbox_1.Checkbox, { value: !!(form === null || form === void 0 ? void 0 : form.values[checkboxId]), "data-testid": checkboxId, secondary: checkboxIsToggle })),
        react_1.default.createElement(Detail_1.Detail, { title: title, description: description })));
};
exports.SelectCard = SelectCard;
//# sourceMappingURL=SelectCard.js.map